import { parrotApi } from '@libs/openapi';
import { useEffect, useState } from 'react';
import { OpenapiClientParrotVault } from 'src/openapi/parrot-vault';
import { useAddress } from './use-address';

export const useCode = () => {
  const address = useAddress();

  const [code, setCode] = useState<OpenapiClientParrotVault.GetVaultInviteCodeResponse>();

  const getVaultCode = async () => {
    if (!address) {
      setCode(undefined);
      return;
    }
    const result = await parrotApi.get('/vault/invite/code', {
      query: {
        owner: address,
      },
    });
    setCode(result);
  };

  useEffect(() => {
    getVaultCode();
  }, [address]);

  return {
    code,
  };
};
